import React from 'react';
import Services from '../../Services/Services';

import Slide from './Slide/Slide';

const Home = () => {
  return (
    <div>
      <Slide></Slide>
     <Services></Services>
    </div>
  );
};

export default Home;